import React, { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  color?: 'gray' | 'blue' | 'green' | 'red' | 'pink' | 'yellow' | 'orange';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  color = 'gray',
  className = ''
}) => {
  const getColorClasses = () => {
    switch (color) {
      case 'blue':
        return 'bg-blue-100 text-blue-800';
      case 'green':
        return 'bg-green-100 text-green-800';
      case 'red':
        return 'bg-red-100 text-red-800';
      case 'pink':
        return 'bg-pink-100 text-pink-800';
      case 'yellow':
        return 'bg-yellow-100 text-yellow-800';
      case 'orange':
        return 'bg-orange-100 text-orange-800';
      case 'gray':
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <span 
      className={`
        inline-flex items-center px-2.5 py-0.5 rounded-full 
        text-xs font-medium ${getColorClasses()} ${className}
      `}
    >
      {children}
    </span>
  );
};

export default Badge;